export const data = [
  {
    id: '1',
    name: 'Virgin Radio Oman',
    tags: 'ECMAScript 6, HTML5, CSS3, PHP Laravel',
    cover: 'img/why-design-matters/01_Virgin/main.jpg',
    photo01: 'img/why-design-matters/01_Virgin/01.jpg',
    alt01: 'App views',
    photo02: 'img/why-design-matters/01_Virgin/02.jpg',
    alt02: 'Product Owner feedback',
    photo03: 'img/why-design-matters/01_Virgin/03.jpg',
    alt03: 'Website view',
    flag: 'img/why-design-matters/flags/Oman.png',
    color: 'alizarin-crimson',
    description:
      'Virgin Radio Oman was a brand new radio station, aiming to reach out to the country’s Millennial music lovers. To do so, the client needed to embrace the latest technologies and decided on web and mobile apps in support of the new station. However, project pressures meant they only had four weeks to do so – a very short design window…\n' +
      'The client’s criteria when choosing a design partner were:\n' +
      'A track record of clean, fresh, responsive designs and web products that target specific demographics.\n' +
      'Technical know-how and experience.\n' +
      'A fresh, disruptive approach to user-centred digital design.\n' +
      'Using the scrum framework and the lean approach to product development, the client and the Boldare design team started with a product vision workshop to explore the product requirements in depth. Deciding on a goal of, “Introducing young, hip music lovers to a completely new disruptive and innovative place they can call their own,” the team set out to create a completely new teenage music experience for Oman.\n' +
      'The rapid creation of prototypes to test specific features led to production of an MVP focused on key functionalities and in line with the strong Virgin brand visual identity\n',
    caseStudyName:
      'From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand',
    caseStudyLink: '/work/case-study-virgin-radio-oman/',
    indigoAward: '',
    awwwards: '',
  },
  {
    id: '2',
    name: 'Eres Yachting',
    tags: 'java, php, symphony',
    cover: 'img/why-design-matters/02_Eres/main.jpg',
    photo01: 'img/why-design-matters/02_Eres/01.jpg',
    alt01: 'Mobile views',
    photo02: 'img/why-design-matters/02_Eres/02.jpg',
    alt02: 'Client feedback',
    photo03: 'img/why-design-matters/02_Eres/03.jpg',
    alt03: 'Mobile views',
    flag: 'img/why-design-matters/flags/swiss.png',
    color: 'pacific-blue',
    description:
      'ERES is a Zurich-based yacht charter agency with a global reach. They came to Boldare looking for a booking website and with their high-end, luxury client base, the design and UX was always going to be crucial and our goal was to produce a top quality responsive design that incorporated the client’s brand identity while meeting the highest UX standards.\n' +
      'To keep the design process tightly focused, we established a ‘product persona’ – the target user. That user was a reasonably well-off man of 40+, with family and a love for nature, traveling and sailing. To attract and engage this specific user, we used high quality marine photos, a very specific color palette, and key marine vocabulary and language to evoke the sailing experience. All the while, maintaining a ‘premium’ look and feel as our core design goal.\n' +
      'For the website, we focused on three key design features to meet the brief:\n' +
      'Homepage search bar – to allow users to simply and easily find charter options according to just two criteria: location and booking date.\n' +
      'Advanced filtering options – initial search results can be filtered for a more precise result according to up to 10 different booking criteria.\n' +
      'Timely suggestions – before booking, each search result or option shows all relevant details and pricing, including alternatives from the weeks immediately before and after the chosen dates.\n',
    caseStudyName:
      'Designing a simple search experience for a complex product with a luxurious interface',
    caseStudyLink: '/work/case-study-eres-yachting-booking-platform/',
    indigoAward: '',
    awwwards: '',
  },
  {
    id: '3',
    name: 'Teal Workspace',
    tags: 'HTML5, CSS3, JavaScript, jQuery',
    cover: 'img/why-design-matters/03_Teal/main.jpg',
    photo01: 'img/why-design-matters/03_Teal/01.jpg',
    alt01: 'Website view',
    photo02: 'img/why-design-matters/03_Teal/02.jpg',
    alt02: 'Designed icons',
    photo03: 'img/why-design-matters/03_Teal/03.jpg',
    alt03: 'Office',
    flag: 'img/why-design-matters/flags/polska.png',
    color: 'wild-watermelon',
    description:
      'Once we were installed in our current office – a custom-designed Teal Workspace! – we wanted to share what we’d created with the wider world. Our accommodation is perfectly suited to augmented teams remotely collaborating with clients to build cutting edge digital products. But the journey wasn’t always easy and we learned a lot along the way. We wanted to share that learning, but how best to do it?\n' +
      'The answer was a landing page that would lay out how we created an office for a contemporary web design and development agency, and also showcase our web design skills, with the aim of boosting the traffic to our main company website by 15%.\n' +
      'However, as the project got underway, we encountered a UX problem: the complex animations we were putting together caused loading speed problems for both desktop and mobile users; both GIFs and short movies were too ‘heavy’ for the site.\n' +
      'Our solution was to write the animations in pure CSS, coding them into the website itself. Every element of each animation was a separate graphics file and each file was animated to achieve the desired outcome: award-winning animations that ‘load’ instantly on a super-light website.\n',
    caseStudyName: '',
    caseStudyLink: '',
    indigoAward: 'https://www.indigoawards.com/winners/549',
    awwwards: 'https://www.awwwards.com/sites/teal-workspace-by-chilid',
  },
  {
    id: '4',
    name: 'A2I',
    tags: 'java, php, symphony',
    cover: 'img/why-design-matters/04_A2I/main.jpg',
    photo01: 'img/why-design-matters/04_A2I/01.jpg',
    alt01: 'App view',
    photo02: 'img/why-design-matters/04_A2I/02.jpg',
    alt02: 'App views',
    photo03: 'img/why-design-matters/04_A2I/03.jpg',
    alt03: 'Client feedback',
    flag: 'img/why-design-matters/flags/saudi.png',
    color: 'bright-turquoise',
    description:
      'In this access to information (A2I) project, we were expanding an app that we’d designed previously.  The original was a business/demographic information platform for Saudi Arabia. The expansion involved adding a new mode to provide small to medium-sized businesses with access to the app’s information, the goal being to assist their development using market information.\n' +
      'For planning purposes, businesses need information about business sectors, the proximity of competition, and the demographic characteristics of the local population. The app would provide this data, and more, via a series of easily-understood, interactive graphical reports with custom filters to enable users to choose which data they need.\n' +
      'The backend technological issues, especially creating a bridge between the Symfony PHP framework used for the original app and React (a new JavaScript library) for the extension, were significant. In turn, this created the challenge to keep the UX smooth and intuitive, unaffected by what might be happening ‘behind the scenes’. Getting to grips with the new React library, we built a seamless user experience for the client, providing their users with exactly the information they needed, when they needed it.\n',
    caseStudyName: '',
    caseStudyLink: '',
    indigoAward: '',
    awwwards: '',
  },
  {
    id: '5',
    name: 'Oneida',
    tags: 'Angular, JavaScript, jQuery, HTML5, CSS3',
    cover: 'img/why-design-matters/05_Oneida/main.jpg',
    photo01: 'img/why-design-matters/05_Oneida/01.jpg',
    alt01: 'Website view',
    photo02: 'img/why-design-matters/05_Oneida/02.jpg',
    alt02: 'App view',
    photo03: 'img/why-design-matters/05_Oneida/03.jpg',
    alt03: 'Website views',
    flag: 'img/why-design-matters/flags/USA.png',
    color: 'rodeo-dust',
    description:
      'Based in the United States, Oneida Ltd. is one of the world’s largest suppliers of stainless steel flatware, and offers a complete range of table top products. The challenge for Boldare was to create not only a website to display the client’s products but to make it a single page application, enabling users to browse every product in one place.\n' +
      'The single page application was the ideal method of creating a virtual table top for users, enabling them to pick and choose the flatware and tableware and then see it in situ as a combined place setting. Naturally, with such a visual focus in the project brief, the design and UX were of paramount importance and moodboards and alternate color palettes were used to offer the client a variety of visual options.\n' +
      'Using JavaScript, Angular and HTML 5, the resulting app not only worked flawlessly (offering 1792 different product combinations) but also provided an intuitive experience for users by using a familiar table top layout.\n',
    caseStudyName: 'How to deliver..',
    caseStudyLink: '',
    indigoAward: '',
    awwwards: '',
  },
];
